<script setup lang="ts">
import { computed, withDefaults } from 'vue'

interface PropTypes {
  color?: string
  size?: number
}

const props = withDefaults(defineProps<PropTypes>(), {
  color: 'slate-900',
  size: 4,
})

const height = computed(() => `h-${props.size}`)
const width = computed(() => `w-${props.size}`)
</script>

<template>
  <div :class="[`bg-${color} rounded-full ${height} ${width}`]"></div>
</template>
